import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { BillingCharge } from '@kawai/shared';
import {
  fetchBillingChargeById,
  fetchBillingChargesByTenant,
} from '../repositories/billingCharges.js';

/**
 * TP-25: テナント別の請求履歴（billing_charges / read 専用）の React Query hook。
 *
 * cache key は `['billing_charges', tenantId]`。tenantId 未確定（空文字）の間は
 * `enabled: false` で fetch しない（ルートパラメータ未解決時のガード）。
 */
export function useBillingCharges(
  tenantId: string,
): UseQueryResult<BillingCharge[], Error> {
  return useQuery({
    queryKey: ['billing_charges', tenantId],
    queryFn: () => fetchBillingChargesByTenant(tenantId),
    enabled: tenantId !== '',
  });
}

/**
 * TP-26: 請求 1 件（billing_charges/{chargeId}）の React Query hook（帳票再発行用 / O(1) read）。
 * 存在しない・tenantId 不一致は null（呼び出し側で「見つかりません」表示）。
 */
export function useBillingCharge(
  tenantId: string,
  chargeId: string,
): UseQueryResult<BillingCharge | null, Error> {
  return useQuery({
    queryKey: ['billing_charge', tenantId, chargeId],
    queryFn: () => fetchBillingChargeById(tenantId, chargeId),
    enabled: tenantId !== '' && chargeId !== '',
  });
}
